import { UseFormRegister, UseFormSetValue } from 'react-hook-form';
import { useAppDispatch, useAppSelector } from '../../hooks/useRedux';
import { formsActions, formsSelectors } from '../../state/forms';
import 'style/fields/_checkbox_field.scss';
import type { ValuesType } from '../../state/forms/forms.reducer';

interface CheckboxProps {
  register: UseFormRegister<ValuesType>;
  formKey: string;
  required?: boolean;
  title: string;
  isDisabled?: boolean;
  setValue?: UseFormSetValue<ValuesType>;
}

const Checkbox = ({
  required = false,
  formKey,
  register,
  title,
  setValue,
  isDisabled,
}: CheckboxProps) => {
  const dispatch = useAppDispatch();

  const defaultLocationKey = useAppSelector(formsSelectors.defaultLocationKeySelector);

  const defaultLocation = () => {
    if (formKey.includes('provider:location'))
      if (setValue && defaultLocationKey !== formKey) {
        setValue(defaultLocationKey, false);
        dispatch(formsActions.setDefaultLocationKey(formKey));
      } else {
        dispatch(formsActions.setDefaultLocationKey(''));
      }
  };

  return (
    <>
      <div className="form-check form-check-inline d-flex align-items-center checkbox-wrapper py-1 my-2">
        <input
          className="form-check-input custom-checkbox cursor-pointer"
          type="checkbox"
          id={formKey}
          disabled={isDisabled}
          {...register(formKey, {
            required,
            onChange: defaultLocation,
          })}
        />
        <label
          className="form-check-label ms-2 cursor-pointer checkbox-label"
          htmlFor={formKey}
        >
          {title}
        </label>

        {required && <span className="text-danger"> *</span>}
      </div>
    </>
  );
};
export default Checkbox;
